import React, { useState, useEffect } from 'react';
import './Home.css';
import Carousel from './Carousel';
import products from '../data/products.json'; // O hacer la solicitud al backend aquí
import ItemProduct from './ItemProducts';
import { Link } from 'react-router-dom';

function Home() {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [noResults, setNoResults] = useState(false);
  const [showResults, setShowResults] = useState(false);  // Nuevo estado para controlar la visibilidad

  // Filtra productos por nombre según lo que el usuario escriba
  useEffect(() => {
    const handleSearch = async () => {
      const searchValue = searchTerm.toLowerCase().trim();

      if (searchValue === '') {
        setFilteredProducts([]);
        setNoResults(false);
        return;
      }

      try {
        const filtered = products.filter((product) =>
          product.name.toLowerCase().includes(searchValue)
        );

        if (filtered.length > 0) {
          setFilteredProducts(filtered);
          setNoResults(false);
        } else {
          setFilteredProducts([]);
          setNoResults(true);
        }
      } catch (error) {
        console.error('Error al buscar productos:', error);
        setFilteredProducts([]);
        setNoResults(true);
      }
    };

    handleSearch();
  }, [searchTerm]);  // Se ejecuta cada vez que el término de búsqueda cambia

  const handleClickItem = () => {
    setShowResults(false);  // Cerrar los resultados al hacer clic en un ítem
  };

  const featured = products.filter((product) => product.featured);
  const promotions = products.filter((product) => product.promotions);

  return (
    <>
      <div className="container-home">
        <h1>POJOBOX 3D</h1>
        <p>Dale forma a tus ideas</p>
        <input
          type="text"
          placeholder="Buscar..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setShowResults(true);  // Mostrar los resultados al escribir
          }}
        />

        {/* Desplegable de productos filtrados */}
        {searchTerm && showResults && (
          <div className="search-results">
            {filteredProducts.length > 0 ? (
              filteredProducts.map((product) => (
                <Link
                  key={product.id}
                  to={`/product/${encodeURIComponent(product.name.toLowerCase().replace(/\s+/g, '-'))}`}
                  className="search-item"
                  onClick={handleClickItem}  // Cerrar el desplegable al hacer clic
                >
                  {product.name}
                </Link>
              ))
            ) : (
              <div>No se encontraron resultados</div>
            )}
          </div>
        )}
      </div>

      {/* Productos Destacados */}
      <section className="container-products-Featured">
        <Carousel title="Productos Destacados">
          {featured.map((product) => (
            <div key={product.id}>
              <ItemProduct product={product} />
            </div>
          ))}
        </Carousel>
      </section>

      {/* Promociones */}
      <section className="container-products-promotions">
        <Carousel title="Promociones">
          {promotions.map((product) => (
            <div key={product.id}>
              <ItemProduct product={product} />
            </div>
          ))}
        </Carousel>
      </section>
    </>
  );
}

export default Home;